import { Injectable } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { APIService } from 'api/module'
import { HelpEndpointResponse } from 'elements-sdk'
import { HelpModalComponent } from 'help/components/helpModal.component'

@Injectable({ providedIn: 'root' })
export class HelpService {
  helpPages = {
    '/status': 'status',
    '/production': 'production',
    '/production/:id': 'production',
    '/workspace': 'workspace',
    '/user': 'users',
    '/user/:id': 'user',
    '/share': 'share',
    '/file-manager': 'file-manager',
    '/download': 'download',
    '/archive/search': 'ltfs',
    '/archive/start': 'ltfs',
    '/archive/restore': 'ltfs',
    '/archive/jobs': 'ltfs',
    '/archive/tapes': 'ltfs',
    '/archive/library': 'ltfs',
    '/system': 'system',
    '/media': 'media',
    '/tasks': 'tasks',
  }

  constructor (
    private api: APIService,
    private ngbModal: NgbModal,
  ) { }

  matchRouteToHelpNote (route: string): string|null {
    let match: string|null = null
    for (const key in this.helpPages) {
      if (key === route) {
        match = this.helpPages[key]
      }
    }
    return match
  }

  async getHelpPage (id: string): Promise<HelpEndpointResponse> {
    return this.api.private.getHelpPage({
      id,
    })
  }

  async openHelp (helpPath: string): Promise<void> {
    const content = await this.getHelpPage(helpPath)
    const m = this.ngbModal.open(HelpModalComponent)
    m.componentInstance.content = content.page
    await m.result.catch(() => null)
  }
}
